const API_ROOT = process.env.REACT_APP_API_ROOT;

const defaultOptions = {
  credentials: 'include',
  mode: 'cors'
};

export const apiConfig = {
  //Extenstion point for common error handling
  errorHandler: (_error) => {}
}

function handleResponse(response) {
  return response.text()
  .then( text => {
    let json;
    try {
      json = JSON.parse(text);
    } catch( error ) {
      //not json
    }

    if(response.ok) {
      return json ? json : text;
    } else {
      const error = {
        message: response.statusText,
        statusText: response.statusText,
        status: response.status,
        ok: response.ok,
      }
      if(json) {
        return Promise.reject(Object.assign({}, error, json))
      } else if (text) {
        return Promise.reject(Object.assign({}, error, {message: text}))
      } else {
        return Promise.reject(Object.assign({}, error))
      }
    }
  });
}

function handleError(error) {
  error = apiConfig.errorHandler(error) || error;
  return Promise.reject({message: error.message, status: error.status, stack: error.stack});
}

function requestWithBody(method, url, payload, options = {}) {
  options = Object.assign({
    method: method,
    body: JSON.stringify(payload),
    headers: new Headers({'Content-Type': 'application/json'})
  }, options);

  return apiCall(url, options);
}

function requestWithoutBody(method, url, options = {}) {
  options = Object.assign({
    method: method,
  }, options);

  return apiCall(url, options);
}

function post(url, payload, options) {
  return requestWithBody('post', url, payload, options);
}

function postForm(url, formData, options = {}) {
  options = Object.assign({
    method: 'post',
    body: formData,
  }, options);
  return apiCall(url, options);
}

function objectIntoQueryParams(object) {
  return Object.keys(object).reduce((qs, key, index) => {
    return `${qs}${index > 0 ? '&' : ''}${key}=${object[key]}`;
  }, '?');
}

function put(url, payload, options) {
  return requestWithBody('put', url, payload, options);
}

function get(url, options) {
  return requestWithoutBody('get', url, options);
}

function del(url, options) {
  return requestWithoutBody('delete', url, options);
}

function apiUrl(endpoint, options = {}) {
  let fullUrl = (!~endpoint.indexOf(API_ROOT)) ? API_ROOT + endpoint : endpoint;
  
  if (!!options.queryParams) {
    fullUrl += objectIntoQueryParams(options.queryParams);
  }

  return encodeURI(fullUrl);
}

function apiCall(endpoint, options = {}) {
  const url = apiUrl(endpoint, options);
  const reqOptions = Object.assign({}, defaultOptions, options);

  return fetch(url, reqOptions)
    .then(handleResponse)
    .catch(handleError);
}

export const customApiCall = (url, options) => apiCall(url, options);
export const getAllUnits = (options) => get('user-management/all-units', options);
export const authentication = (options) => get('authentication', options);
export const findAllLessons = (options) => get('lessons-api/v1/lessons/all', options);
export const getPauseTypes = (options) => get('lessons-api/v1/lessons/lesson-pause-types', options);
export const login = (payload, options) => post('login', payload, options);
export const logout = (options) => get('logout', options);
export const searchLessons = (payload, options) => post('lessons-api/v1/lessons/search', payload, options);
export const searchApplicants = (payload, options) => post('lessons-api/v1/applicants/search', payload, options);
export const addLessonEntries = (payload, options) => post('lessons-api/v1/lessons/add-entries', payload, options);
export const addDrivingLessonEntries = (payload, options) => post('lessons-api/v1/lessons/add-driving-lesson-entries', payload, options);
export const getApplicantById = (id, options) => get(`lessons-api/v1/applicant/${id}`, options);
export const getGeneralData = (options) => get(`lessons-api/v1/lessons/general`, options);
export const updateLessonEntry = (id, newDateString, payload, options) => put(`lessons-api/v1/lesson-entry/update/${id}/${newDateString}`, payload, options);
export const updateDrivingLessonEntry = (id, payload, options) => put(`lessons-api/v1/lesson-entry/update/driving/${id}`, payload, options);
export const removeLessonEntry = (applicantId, lessonEntryId, options) => del(`lessons-api/v1/lesson-entry/remove/${applicantId}/${lessonEntryId}`, options);
export const updateApplicant = (id, payload, options) => put(`lessons-api/v1/applicant/update/${id}`, payload, options);
export const fetchLessonData = (id, options) => get(`lessons-api/v1/lessons/${id}`, options);
export const updateLesson = (id, payload, options) => put(`lessons-api/v1/lessons/update/${id}`, payload, options);
export const addLesson = (payload, options) => post(`lessons-api/v1/lessons/add`, payload, options);
export const removeLesson = (id, options) => del(`lessons-api/v1/lessons/remove/${id}`, options);
export const courseReport = (payload, options) => post(`lessons-api/v1/lessons/report`, payload, options);
export const uploadData = (payload, options) => postForm(`lessons-api/v1/import`, payload, options);
export const getApplicantDriverCardDownloadUrl = (applicantId, course) => apiUrl(`drivercard/${course.courseNumber}/${course.courseYear}/${course.courseUnit}/${applicantId}/pdf`);
export const getCourseDriverCardDownloadUrl = (course) => apiUrl(`drivercard/${course.courseNumber}/${course.courseYear}/${course.courseUnit}/pdf`);
export const getCourseLessons = (course, options) => get(`lessons-api/v1/course/extended/${course.courseNumber}/${course.courseYear}/${course.courseUnit}`, options);



// WEBPACK FOOTER //
// ./src/service/api.js